const API_URL = (process.env.REACT_APP_API_URL || 'https://kapal-badyal-wai-project.vercel.app').replace(/\/$/, '');

export default API_URL;
